export const setOptionsForInviteToWorkspaceModal = ({ mentionedNewEmail = '', workspaceId = null }) => ({
  type: 'SET_OPTIONS_FOR_INVITE_TO_WORKSPACE_MODAL',
  payload: {
    mentionedNewEmail,
    workspaceId,
  },
});

export const resetOptionsForInviteToWorkspaceModal = () => ({ type: 'RESET_OPTIONS_FOR_INVITE_TO_WORKSPACE_MODAL' });
